import { render, staticRenderFns } from "./NewREVRequest.vue?vue&type=template&id=e3a3c6d2&"
import script from "./NewREVRequest.vue?vue&type=script&lang=js&"
export * from "./NewREVRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports